// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_bootstrap_tsx":"21528ac9","vendors-node_modules_presta-prenda-front-ds-revamped_dist_index_js":"682fd739"}[chunkId] + ".css";
};